import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=68232717"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports